import "./checkout-page.style.scss";

import { Container, Row } from "@amzn/stencil-react-components/layout";
import { IItemVersion } from "@/common/types/item.types";
import { CheckoutItemSidePanel } from "@/pages/Checkout/components/CheckoutItemSidePanel/checkout-item-side-panel";
import { CheckoutFormPanel } from "@/pages/Checkout/components/CheckoutFormPanel/checkout-form-panel";
import { Paths } from "@/common/paths/paths";
import React, { useState } from "react";
import { Redirect, useLocation } from "react-router-dom";

interface CheckoutLocationState {
  versions: IItemVersion[];
  defaultVersion: IItemVersion;
  parentName?: string;
  parentTxId?: string;
}

const CheckoutPage: React.FC = () => {
  const location = useLocation<CheckoutLocationState | undefined>();
  const state = location.state;

  const [selectedVersion, setSelectedVersion] = useState<IItemVersion | undefined>(state?.defaultVersion);

  if (!state || !state.defaultVersion || !selectedVersion) {
    return <Redirect to={Paths.search.url} />;
  }

  return (
    <Container isFullWidth={true}>
      <Row>
        <CheckoutItemSidePanel
          versions={state.versions ?? []}
          parentName={state.parentName}
          selectedVersion={selectedVersion}
          onVersionChange={setSelectedVersion}
        />
        <CheckoutFormPanel selectedVersion={selectedVersion} />
      </Row>
    </Container>
  );
};

export default CheckoutPage;
